export const localizations = [
  { locale: "cs", file: () => import("./cs.json") },
  { locale: "de", file: () => import("./de.json") },
  { locale: "en", file: () => import("./en.json") },
  { locale: "es", file: () => import("./es.json") },
  { locale: "hu", file: () => import("./hu.json") },
  { locale: "ro", file: () => import("./ro.json") },
  { locale: "sk", file: () => import("./sk.json") },
  { locale: "uk", file: () => import("./uk.json") },
];
